import _ from 'underscore'
import CreateSchoolViewTemplate from '../templates/create-school.tpl'
import FormView from './form'
import messages from '../messages'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const CreateSchoolView = FormView.extend({
    events: {
        'click .submit': 'createSchool',
    },
    initialize() {
        this.template = _.template(CreateSchoolViewTemplate)
    },
    createSchool() {
        // set the school changes
        const name = this.$el.find('#name').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (name.trim() === '') {
                reject(messages.MSG_SCHOOL_NAME_BLANK)
            }
            resolve()
        })
            .then(() => this.model.get('school').create(name))
            .then(() => Backbone.history.navigate('school', {trigger: true}))
            .catch(Alert)
    }
})

export default CreateSchoolView
